import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const SelectedTemplate = ({ template, selectSurvey }) => (
  <div className="selected-template justify-content-between">
    {template.name}
    <div className="clear-btn cursor-pointer ml-2" onClick={() => selectSurvey(template)}>
      <FontAwesomeIcon icon="times" />
    </div>
  </div>
);

SelectedTemplate.propTypes = {
  template: PropTypes.shape({
    name: PropTypes.string
  }),
  selectSurvey: PropTypes.func
};

const SelectedTemplatesBar = ({ selectedTemplates, selectSurvey }) => {
  const selectedTemplatesList = selectedTemplates.map(template =>
    <SelectedTemplate
      template={template}
      selectSurvey={selectSurvey}
    />
  );

  return (
    <div className="col-12 d-flex align-items-start justify-content-start pd-selected-template">
      {
        !selectedTemplates.length ? "Selected templates will appear here." : selectedTemplatesList
      }
    </div>
  );
};

SelectedTemplatesBar.propTypes = {
  selectedTemplates: PropTypes.array,
  selectSurvey: PropTypes.func
};

export default SelectedTemplatesBar;



// WEBPACK FOOTER //
// ./src/components/survey-templates/SelectedTemplatesBar.js